module.exports = __webpack_public_path__ + "img/1.cb33139c.png";